export enum PalantirBannerVariantEnum {
  info = 'info',
  negative = 'negative',
  positive = 'positive',
  warning = 'warning',
}

export type PalantirBannerVariant = keyof typeof PalantirBannerVariantEnum;

export enum PalantirBannerThemeEnum {
  default = 'default',
  outline = 'outline',
}

export type PalantirBannerTheme = keyof typeof PalantirBannerThemeEnum;
